import gsap from 'gsap';
import $ from '@modules/jquery-import';
import {getNumberOfDaysFromNow} from '@util/DateUtils';

export default function CreateProcedureTracker ( selector = '#procedureTrackerBanner' ) {
    const $procedureBanner = $( selector );
    const $procedureCount = $( '#procedureCount' );

    let lastUpdatedDate = new Date( $procedureBanner.data( 'lastUpdated' ) );
    const totalCountInDay = parseInt( $procedureBanner.data( 'yesterday' ), 10 );
    const totalBeforeYesterday = parseInt( $procedureBanner.data( 'beforeYesterday' ), 10 );

    if ( !Number.isFinite( totalCountInDay ) || !Number.isFinite( totalBeforeYesterday ) ) {
        console.error( 'Procedure Tracker Error: Invalid data attributes.', {
            totalCountInDay, totalBeforeYesterday, lastUpdatedDate
        } );
        return;
    }
    if ( lastUpdatedDate.toString() === 'Invalid Date' ) {
        lastUpdatedDate = new Date();
    }

    function getWeightedCurveValue ( percent, weight = 1.0 ) {
        const clamped = Math.max( 0, Math.min( 1, percent ) );
        const x = clamped * Math.PI;
        return Math.sin( x ) ** weight;
    }

    function calculateNextWeightedTargetValue () {
        const now = new Date();
        const secondsElapsedToday = now.getHours() * 3600 + now.getMinutes() * 60 + now.getSeconds();
        const percentOfDayElapsed = secondsElapsedToday / 86400;
        const weight = getWeightedCurveValue( percentOfDayElapsed, 5.0 );
        const h = totalCountInDay / 2;

        const nextCount = percentOfDayElapsed <= 0.5 ? weight * h : h + (h - (weight * h));

        return Math.floor( nextCount );
    }

    function getNextTotal ( lastUpdatedDate ) {
        const nextCount = calculateNextWeightedTargetValue();
        const updatedDaysAgo = getNumberOfDaysFromNow( lastUpdatedDate );
        return nextCount + totalBeforeYesterday + (totalCountInDay * updatedDaysAgo);
    }

    function updateAndScheduleNext ( lastUpdatedDate ) {
        $procedureCount.text( (getNextTotal( lastUpdatedDate )).toLocaleString() );
        setTimeout( () => updateAndScheduleNext( lastUpdatedDate ), 1000 );
    }

    // prime the counter DOM
    $procedureCount.text( totalBeforeYesterday );

    // we initialize with a startup animation, then initialize the counter
    gsap.to( $procedureCount[0], {
        textContent: getNextTotal( lastUpdatedDate ), duration: 2.5, ease: 'expo.out', onUpdate: function () {
            const output = Math.ceil( this.targets()[0].textContent );
            this.targets()[0].innerHTML = output.toLocaleString();
        }, onComplete: function () {
            updateAndScheduleNext( lastUpdatedDate );
        }
    } );
}
